import React, { ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { VerifiedInvitation } from '../../../network/api/types/InvitationDTO';
import ActivationHeader from '../accountActivation/ActivationHeader';
import ActivationPassword from '../accountActivation/ActivationPassword';
import ActivationMail from '../accountActivation/ActivationMail';
import DoneModal from './components/DoneModal';
import CreationIds from './CreationIds';
import CreationStructurePro from './CreationStrucutrePro';
import { InscriptionDTO } from '../../../network/api/types/InscriptionDTO';
import AlmostDoneModal from './components/AlmostDoneModal';
import creationApi from '../../../network/api/creationApi';
import { toastError } from '../../common/Notification';
import PicturePopin from '../../external/PicturePopin';
import photo from '../../../img/createAccount/photo_vide.svg';
import Footer from '../../layout/Footer';
import SelectedStrucutrePro from './SelectedStrucutrePro';

type Props = RouteComponentProps<unknown, null, { verifiedInvitation: VerifiedInvitation }>;

type State = {
  index: number;
  inscription: InscriptionDTO;
  enrolementInvitation: VerifiedInvitation;
  isAlmostDoneModal: boolean,
  isDoneModal: boolean,
  openImagePopin: boolean,
  photo: string,
  resizing: boolean,
  isLoading: boolean,
};

class AccountCreation extends React.Component<Props, State> {
  state: State = {
    index: 0,
    inscription: {
      nomUsuel: null,
      prenom: null,
      nomDeNaissance: null,
      dateDeNaissance: null,
      communeDeNaissance: null,
      paysDeNaissanceLabel: 'France',
      paysDeNaissance: 'FR',
      civilite: null,
      pseudo: null,
      password: null,
      photo: null,
      entities: [],
      invitationId: null,
    },
    enrolementInvitation: null,
    isAlmostDoneModal: false,
    isDoneModal: false,
    openImagePopin: false,
    photo: null,
    resizing: false,
    isLoading: false,
  };

  animationdurantion = 400;

  minwidth = 25;

  maxpourcentage = 75;

  progressBarScroll = (): void => {
    setTimeout(() => {
      const winScroll = this.scrollableRef.current.scrollTop;
      const height = this.findPos(this.creationIdsRef.current, 3);
      const scrolled = this.minwidth + (winScroll / height) * this.maxpourcentage;
      this.progressBarRef.current.style.width = `${scrolled}%`;
    }, this.animationdurantion);
  };

  resizePage = (): void => {
    if (!this.state.resizing) {
      this.setState({ resizing: true });
      setTimeout(() => {
        this.scrollableRef.current.style.height = `calc(100vh - ${this.headerRef.current ? this.headerRef.current.getBoundingClientRect().height : 130}px - ${this.footerRef.current ? this.footerRef.current.getBoundingClientRect().height : 37}px)`;
        this.setState({ resizing: false });
      }, this.animationdurantion);
    }
  };

  componentDidMount(): void {
    this.scrollableRef.current.addEventListener('scroll', this.progressBarScroll);
    window.addEventListener('resize', this.resizePage);
    this.initializeEnrolementProcess();
  }

  initializeEnrolementProcess = () => {
    if (!this.props.location.state?.verifiedInvitation) {
      return;
    }
    const invitation = this.props.location.state.verifiedInvitation;
    this.setState((currentState) => ({
      inscription: {
        ...currentState.inscription,
        prenom: invitation.firstName,
        nomUsuel: invitation.lastName,
        email: invitation.email,
        civilite: invitation.gender,
      },
      enrolementInvitation: invitation,
    }));
  };

  componentWillUnmount(): void {
    this.scrollableRef.current.removeEventListener('scroll', this.progressBarScroll);
    window.removeEventListener('resize', this.resizePage);
  }

  headerRef = React.createRef<HTMLDivElement>();

  footerRef = React.createRef<HTMLElement>();

  scrollableRef = React.createRef<HTMLDivElement>();

  creationIdsRef = React.createRef<HTMLDivElement>();

  activationMailRef = React.createRef<HTMLDivElement>();

  activationPasswordRef = React.createRef<HTMLDivElement>();

  creationStructureProRef = React.createRef<HTMLDivElement>();

  progressBarRef = React.createRef<HTMLDivElement>();

  findPos = (obj: HTMLDivElement, index: number): number => {
    const height = obj.getBoundingClientRect().height;
    return height * index;
  };

  goto = (index: number): void => {
    this.setState((prevState: State) =>
      ({ index: prevState.index > index ? prevState.index : index }),
    () => {
      if (this.scrollableRef.current.scroll) {
        this.scrollableRef.current.scroll({
          top: this.findPos(this.creationIdsRef.current, index),
          behavior: 'smooth',
        });
      } else {
        // IE11
        this.scrollableRef.current.scrollTop = this.findPos(this.creationIdsRef.current, index);
      }
    });
  };

  toogleImagePopin = (): void => {
    this.setState((previousState: State) => ({ openImagePopin: !previousState.openImagePopin }));
  };

  updatePhoto = (photoURL: string): void => {
    this.setState({ photo: photoURL });
    this.onChange(0);
  };

  onChange = (index: number): void => {
    if (index < this.state.index) {
      this.setState(() => ({ index }),
        () => {
          if (this.scrollableRef.current.scroll) {
            this.scrollableRef.current.scroll({
              top: this.findPos(this.creationIdsRef.current, index),
              behavior: 'smooth',
            });
          } else {
            // IE11
            this.scrollableRef.current.scrollTop = this.findPos(this.creationIdsRef.current, index);
          }
        });
    }
  };

  updateUserData = (values: InscriptionDTO, index: number): void => {
    this.setState((previousState: State) => ({
      inscription: {
        ...previousState.inscription,
        ...values,
      },
    }));
    if (index !== null) {
      this.goto(index);
    }
  };

  endForm = (values: InscriptionDTO): void => {
    this.setState({ isLoading: true });
    const isEnrolement = !!this.state.enrolementInvitation;

    this.updateUserData(values, null);
    const user = {
      ...this.state.inscription,
      ...values,
      invitationId: isEnrolement ? this.state.enrolementInvitation.id : null,
      photo: this.state.photo,
    };

    if (isEnrolement) {
      creationApi
        .enrole(user)
        .then(() => {
          this.setState({ isLoading: false });
          this.openDoneModal();
        })
        .catch((e) => {
          this.setState({ isLoading: false });
          if (typeof e.then === 'function') {
            e.then((err) => {
              const error = err.fieldErrors ? err.fieldErrors[0].message : err.message;
              toastError(error);
            });
          }
        });
    } else {
      creationApi
        .signup(user)
        .then(() => {
          this.setState({ isLoading: false });
          this.openAlmostDoneModal();
        })
        .catch((e) => {
          this.setState({ isLoading: false });
          if (typeof e.then === 'function') {
            e.then((err) => {
              const error = err.fieldErrors ? err.fieldErrors[0].message : err.message;
              toastError(error);
            });
          }
        });
    }
  };

  openAlmostDoneModal = (): void => {
    this.setState((prevState: State) => ({ isAlmostDoneModal: !prevState.isAlmostDoneModal }));
  };

  openDoneModal = (): void => {
    this.setState((prevState: State) => ({ isDoneModal: !prevState.isDoneModal }));
  };

  render(): ReactNode {
    const { enrolementInvitation, inscription, index } = this.state;
    return (
      <div className="parcours">
        <ActivationHeader
          progressBarRef={this.progressBarRef}
          title="CREATION.TITLE"
          percentOfStep={25}
          divRef={this.headerRef}
          index={this.state.index}
        />
        <AlmostDoneModal
          isOpen={this.state.isAlmostDoneModal}
          openModal={this.openAlmostDoneModal}
          email={inscription.email}
          isCreation
        />
        <DoneModal
          isOpen={this.state.isDoneModal}
          closeModal={this.openDoneModal}
          entity={enrolementInvitation?.entityName}
        />
        <PicturePopin
          isOpen={this.state.openImagePopin}
          onClose={this.toogleImagePopin}
          image={this.state.photo || photo}
          imageChanged={this.updatePhoto}
        />
        <div
          style={{ height: `calc(100vh - ${this.headerRef.current ? this.headerRef.current.getBoundingClientRect().height : 130}px - ${this.footerRef.current ? this.footerRef.current.getBoundingClientRect().height : 37}px)` }}
          ref={this.scrollableRef}
          className="activation-forms-container"
        >
          <div className={`variable-height height${index + 1}`}>
            <CreationIds
              update={(values) => this.updateUserData(values, 1)}
              divRef={this.creationIdsRef}
              onChange={this.onChange}
              initial={inscription}
              openPhotoModal={this.toogleImagePopin}
              photo={this.state.photo || photo}
              isEnrolement={!!this.state.enrolementInvitation}
            />
            {index >= 1
            && (
            <ActivationPassword
              update={(values) => this.updateUserData(values, 2)}
              divRef={this.activationPasswordRef}
              suggestedPseudo={inscription.pseudo}
              onChange={this.onChange}
              initial={inscription}
            />
            )}
            {index >= 2
            && (
              <>
                {enrolementInvitation
                  ? (
                    <SelectedStrucutrePro
                      divRef={this.creationStructureProRef}
                      update={(values) => this.updateUserData(values, 3)}
                      entityId={enrolementInvitation.entityId}
                    />
                  )
                  : (
                    <CreationStructurePro
                      update={(values) => this.updateUserData(values, 3)}
                      divRef={this.creationStructureProRef}
                      onChange={this.onChange}
                      initialSelectedStructure={inscription.entities}
                    />
                  )}
              </>
            )}
            {index >= 3
            && (
            <ActivationMail
              divRef={this.activationMailRef}
              endForm={(values) => this.endForm(values)}
              isLoading={this.state.isLoading}
              initialMail={inscription.email}
              fromEnrolement={!!this.state.enrolementInvitation}
            />
            )}
          </div>
        </div>
        <Footer footerRef={this.footerRef} />
      </div>
    );
  }
}

export default withRouter(AccountCreation);
